import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5605cc22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex-column wrap" }
const _hoisted_2 = { class: "searchWrap" }
const _hoisted_3 = { class: "d-flex-1f d-overflow-not" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "coverWarp" }
const _hoisted_6 = { class: "activityDays text-xs" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "d-flex van-row--align-center van-row--justify-space-between" }
const _hoisted_9 = {
  class: "text-sm",
  style: {"color":"#909399"}
}
const _hoisted_10 = { class: "d-flex van-row--align-center" }
const _hoisted_11 = { class: "area text-xs" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs",
  style: {"color":"#909399"}
}
const _hoisted_13 = {
  key: 1,
  class: "text-xs",
  style: {"color":"#909399"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_app_list = _resolveComponent("app-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_search, {
        onSearch: _ctx.refreshData,
        shape: "round",
        modelValue: _ctx.formData.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
        placeholder: "疫情志愿者招募"
      }, null, 8, ["onSearch", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_app_list, {
        onLoadData: _ctx.loadOrganizeActivitiy,
        ref: "appListRef"
      }, {
        default: _withCtx(({list}) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.goToActivityDescription(item)),
              class: _normalizeClass(["activeItem", [{'margin-bottom-0': index == list.length-1}]]),
              key: index
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_van_image, {
                  class: "banner-item-img-wrapper",
                  width: "100%",
                  height: "9.875rem",
                  alt: "图片加载中...",
                  radius: 12,
                  fit: "cover",
                  src: _ctx.img(item.img)
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatData().formatActivityDay(item.startTime, item.endTime, item.activitiyStatus)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(item.organizatioName), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(item.district), 1),
                  (item.signupNum == -1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.checkInNum) + "人", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.checkInNum) + "/" + _toDisplayString(item.signupNum) + "人", 1))
                ])
              ])
            ], 10, _hoisted_4))
          }), 128))
        ]),
        _: 1
      }, 8, ["onLoadData"])
    ])
  ]))
}